import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";
import { IQuyDinhDangKyVm } from "../../../model/respone/lop-tin-chi/IQuyDinhDangKyVm";
import { IQuyDinhSoTinChi } from "../../../model/respone/lop-tin-chi/IQuyDinhSoTinChi";
import { IQuyDinhSoTinChiViewModel } from "../../../model/respone/lop-tin-chi/IQuyDinhSoTinChiViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQuyDinhSoTinChiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IQuyDinhDangKyVm[],
    LOAD_ERROR: "",

    SAVE_START: {} as IQuyDinhSoTinChi,
    SAVE_SUCCESS: {} as IQuyDinhSoTinChi,
    SAVE_ERROR: "",

    DELETE_START: 0 as number,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: {} as IQuyDinhSoTinChiViewModel | undefined,
    CLOSE_EDIT_MODAL: undefined,

    CHANGE_SELECTED_IDS: {} as number[],
    CHANGE_FOCUSED_ID: 0 as number,

    SUBMIT_START: {} as IQuyDinhSoTinChiViewModel,
    SUBMIT_SUCCESS: undefined,
    SUBMIT_ERROR: "",

    LOAD_BY_HOC_KY_NAM_HOC_START: {} as { hocKy: number, namHoc: string },
    LOAD_BY_HOC_KY_NAM_HOC_SUCCESS: {} as IQuyDinhSoTinChiViewModel[],
    LOAD_BY_HOC_KY_NAM_HOC_ERROR: "",


};

export const eQuyDinhSoTinChiActionIds = generateActionTypeIds(
    eQuyDinhSoTinChiActionsObj,
    "QUY_DINH_SO_TIN_CHI"
);

export type IQuyDinhSoTinChiActionTypes = IGenericActionType<
    typeof eQuyDinhSoTinChiActionsObj,
    "QUY_DINH_SO_TIN_CHI"
>;
